module.exports = __webpack_public_path__ + "static/media/img1-2.691fd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/manzano/nutricheck_foliar/N/img1-2.png
// module id = 1790
// module chunks = 3